import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AnalysisModule from '../components/AnalysisModule';
import History from '../components/History';
import { initFirebase, saveAnalysis, subscribeToHistory } from '../firebase';

const MackSpyman04 = () => {
  const [userId, setUserId] = useState(null);
  const [authStatus, setAuthStatus] = useState('Cargando autenticación...');
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    const init = async () => {
      const uid = await initFirebase();
      if (uid) {
        setUserId(uid);
        setAuthStatus(`✅ Conectado`);
        
        const unsubscribe = subscribeToHistory(uid, (data) => {
          setAnalyses(data);
        });
        
        return () => unsubscribe();
      } else {
        setAuthStatus('⚠️ No hay usuario autenticado');
      }
    };
    
    init();
  }, []);

  const handleSave = (query, result, type) => {
    if (userId) {
      saveAnalysis(userId, query, result, type);
    }
  };

  return (
    <div className="container">
      <Header 
        title="Mackinder vs Spykman" 
        subtitle="Heartland vs Rimland: El Gran Debate"
        authStatus={authStatus}
      />

      <section className="card" style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#004e92', marginBottom: '1rem' }}>
          El Gran Debate Geopolítico
        </h2>
        <p style={{ lineHeight: '1.7', maxWidth: '800px', margin: '0 auto 1.5rem' }}>
          Nicholas Spykman desafió directamente la teoría de Mackinder, argumentando que el Rimland, no el Heartland, era la clave del poder mundial.
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#004e92' }}>
          Comparación de Teorías
        </h3>
        <div className="grid">
          <div className="card" style={{ borderTop: '4px solid #3b82f6' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#3b82f6', textAlign: 'center' }}>
              🏔️ Mackinder: Heartland
            </h3>
            <div style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Tesis Central:</p>
              <p style={{ fontSize: '0.95rem', fontStyle: 'italic' }}>
                "Quien controle el Heartland dominará la Isla-Mundo"
              </p>
            </div>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Argumentos:</p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li>Recursos naturales abundantes</li>
              <li>Inaccesible al poder naval</li>
              <li>Posición central en Eurasia</li>
              <li>Autosuficiencia económica</li>
            </ul>
            <p style={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '0.5rem' }}>Zona Clave:</p>
            <p>Rusia, Asia Central, Europa del Este</p>
          </div>

          <div className="card" style={{ borderTop: '4px solid #8b5cf6' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#8b5cf6', textAlign: 'center' }}>
              🌊 Spykman: Rimland
            </h3>
            <div style={{ backgroundColor: 'rgba(139, 92, 246, 0.1)', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1rem' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Tesis Central:</p>
              <p style={{ fontSize: '0.95rem', fontStyle: 'italic' }}>
                "Quien controle el Rimland dominará Eurasia y el mundo"
              </p>
            </div>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Argumentos:</p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li>Mayor población y economía</li>
              <li>Acceso a mares y océanos</li>
              <li>Centros industriales avanzados</li>
              <li>Puede contener al Heartland</li>
            </ul>
            <p style={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '0.5rem' }}>Zona Clave:</p>
            <p>Europa Occidental, Medio Oriente, India, China, Japón</p>
          </div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          ⚔️ Puntos de Conflicto
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(239, 68, 68, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #ef4444' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: '#ef4444' }}>🎯 Enfoque Geográfico</p>
            <p style={{ fontSize: '0.9rem' }}><strong>Mackinder:</strong> Interior continental</p>
            <p style={{ fontSize: '0.9rem' }}><strong>Spykman:</strong> Zonas costeras</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(59, 130, 246, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #3b82f6' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: '#3b82f6' }}>⚓ Tipo de Poder</p>
            <p style={{ fontSize: '0.9rem' }}><strong>Mackinder:</strong> Poder terrestre</p>
            <p style={{ fontSize: '0.9rem' }}><strong>Spykman:</strong> Poder anfibio (tierra + mar)</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(234, 179, 8, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #eab308' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: '#eab308' }}>🛡️ Estrategia</p>
            <p style={{ fontSize: '0.9rem' }}><strong>Mackinder:</strong> Controlar el centro</p>
            <p style={{ fontSize: '0.9rem' }}><strong>Spykman:</strong> Contener desde la periferia</p>
          </div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          🏆 ¿Quién Tenía Razón?
        </h3>
        <p style={{ textAlign: 'center', marginBottom: '1.5rem', lineHeight: '1.7' }}>
          La historia del siglo XX sugiere que <strong>ambos tenían razón parcialmente</strong>:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(34, 197, 94, 0.1)', borderRadius: '0.5rem' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: '#22c55e' }}>✓ Mackinder Correcto</p>
            <p style={{ fontSize: '0.9rem' }}>El control de Europa del Este fue crucial en ambas guerras mundiales</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(34, 197, 94, 0.1)', borderRadius: '0.5rem' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem', color: '#22c55e' }}>✓ Spykman Correcto</p>
            <p style={{ fontSize: '0.9rem' }}>La contención del Rimland funcionó durante la Guerra Fría</p>
          </div>
        </div>
      </section>

      <AnalysisModule
        title="✨ Análisis Comparativo"
        description="Compare las dos teorías en un contexto específico."
        inputType="textarea"
        systemPrompt="Actúa como un experto en geopolítica comparada. Analiza el escenario proporcionado desde las perspectivas de Mackinder (Heartland) y Spykman (Rimland). Explica qué teoría es más aplicable y por qué. Responde en español de forma concisa."
        onSave={handleSave}
        type="section"
      />

      <History analyses={analyses} />

      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', gap: '10px', zIndex: 1000 }}>
        <Link to="/mackinder03" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          ⬅️ Anterior
        </Link>
        <Link to="/" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          🏠 Inicio
        </Link>
        <Link to="/mackinder05" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          Siguiente ➡️
        </Link>
      </div>
    </div>
  );
};

export default MackSpyman04;
